import { NotificationScopeBadge } from '@ayocore/platform/notifications/client';
import { PROCUREMENT_SUPPLIER_INVOICES_NOTIFICATION_SCOPE } from '../../notification-scopes';

/** Непрочитанные уведомления счетов поставщиков в реестре платежей. */
export function SupplierInvoicesMenuBadge() {
  return <NotificationScopeBadge scope={PROCUREMENT_SUPPLIER_INVOICES_NOTIFICATION_SCOPE} />;
}
